import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {hideAlert} from '../actions/AlertActions';
import {useLocation} from '../imports/Router';
import {selectrootalerttype} from '../selectors/AlertSelector';

const HideLoading = () => {
  const dispatch = useDispatch();
  const {id} = useSelector(state => selectrootalerttype(state));
  const location = useLocation();
  useEffect(() => {
    if (id === 'Loading') {
      dispatch(hideAlert());
    }
  }, [dispatch, location?.pathname]);
};
export default HideLoading;
